import { render, staticRenderFns } from "./ExpertEmployeesTable.vue?vue&type=template&id=7166f8eb&scoped=true&lang=pug"
import script from "./ExpertEmployeesTable.vue?vue&type=script&lang=ts"
export * from "./ExpertEmployeesTable.vue?vue&type=script&lang=ts"
import style0 from "./ExpertEmployeesTable.vue?vue&type=style&index=0&id=7166f8eb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166f8eb",
  null
  
)

/* custom blocks */
import block0 from "./ExpertEmployeesTable.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FComponents%2FTable%2FExpertEmployeesTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports